import { render, staticRenderFns } from "./FoodPairing.vue?vue&type=template&id=6373bc5c"
import script from "./FoodPairing.vue?vue&type=script&lang=js"
export * from "./FoodPairing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports